/* Physician Resources Center: HCP registration -> Klaviyo list (double opt-in is set on the list).
   Ported from Prototype v3 src/site.js. Keys come from data attributes on #hcp-form. */
(function () {
  function q(id) { return document.getElementById(id); }

  function params() {
    var o = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (kv) {
      if (!kv) return;
      var p = kv.split('=');
      o[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
    });
    return o;
  }

  function init() {
    var form = q('hcp-form');
    if (!form) return;
    var companyId = form.getAttribute('data-company-id') || '';
    var listId = form.getAttribute('data-list-id') || '';
    var p = params();

    if (p.interest) {
      p.interest.split(',').forEach(function (v) {
        var box = form.querySelector('input[name=interest][value="' + v + '"]');
        if (box) box.checked = true;
      });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var err = q('reg-error');
      err.hidden = true;
      if (!form.checkValidity()) {
        err.textContent = 'Please complete the required fields and the attestation.';
        err.hidden = false;
        if (form.reportValidity) form.reportValidity();
        return;
      }

      var interests = [].slice.call(form.querySelectorAll('input[name=interest]:checked')).map(function (b) { return b.value; });
      var v = function (n) { return (form.elements[n].value || '').trim(); };
      var props = {
        hcp: true,
        hcp_specialty: v('specialty'),
        hcp_practice_name: v('practice'),
        hcp_state: v('state').toUpperCase(),
        hcp_npi: v('npi'),
        hcp_attested: true,
        hcp_interests: interests,
        hcp_wants_discount_code: interests.indexOf('discount') > -1,
        hcp_wants_literature: interests.indexOf('literature') > -1,
        hcp_wants_order: interests.indexOf('order') > -1,
        hcp_literature_item: p.item || '',
        hcp_signup_page: location.pathname,
        utm_source: p.utm_source || '',
        utm_medium: p.utm_medium || '',
        utm_campaign: p.utm_campaign || '',
        utm_content: p.utm_content || ''
      };
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Physician Resources Center',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: v('email'),
                  first_name: v('first_name'),
                  last_name: v('last_name'),
                  organization: v('practice'),
                  location: { region: v('state').toUpperCase(), country: 'United States' },
                  properties: props
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      var done = function () {
        q('reg-done-email').textContent = v('email');
        q('reg-form').hidden = true;
        q('reg-done').hidden = false;
        q('reg-done').scrollIntoView({ block: 'center' });
      };

      if (!listId || !companyId) {
        console.log('[PRC] No Klaviyo list configured; nothing sent. Payload:', payload);
        done();
        return;
      }

      var btn = q('reg-submit');
      btn.disabled = true;
      btn.textContent = 'Sending…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.status === 202 || r.ok) { done(); return; }
        return r.text().then(function (t) { throw new Error(r.status + ' ' + t); });
      }).catch(function (e) {
        console.log('[PRC] Klaviyo error', e);
        err.innerHTML = 'Something went wrong. Please try again, or email <a href="mailto:support@definedsleep.com?subject=Provider%20Inquiry">support@definedsleep.com</a>.';
        err.hidden = false;
        btn.disabled = false;
        btn.textContent = 'Register';
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
